import PropTypes from 'prop-types'
import React from 'react'
import Day from './Day'

function ClinicalCaresSchedules({ clinicId, dates, data }) {
  const days = dates.map(({ scheduledTo }) => scheduledTo)

  const getCount = (day) => {
    const reference = data?.[clinicId]?.dates?.find((ref) => ref?.scheduledTo === day)
    return reference?.count ?? 0
  }

  return (
    <div style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: 500 }}>
      {
        days.map((day) => (
          <Day key={day} count={getCount(day)} clinicId={clinicId} day={day} />
        ))
      }
    </div>
  )
}

ClinicalCaresSchedules.propTypes = {
  dates: PropTypes.arrayOf(Object).isRequired,
  data: PropTypes.objectOf(Object).isRequired,
  clinicId: PropTypes.number.isRequired,
}

export default ClinicalCaresSchedules
